"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
  id: "close-a",
  d: "M13 11h5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-5v5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5H6c-.5523 0-1-.4477-1-1s.4477-1 1-1h5V6c0-.5523.4477-1 1-1s1 .4477 1 1v5z"
})), /*#__PURE__*/_react["default"].createElement("use", {
  fillRule: "evenodd",
  transform: "rotate(-45 12 12)",
  xlinkHref: "#close-a"
})), 'CloseIcon');
/* eslint-enable */


exports["default"] = _default;